import { render, staticRenderFns } from "./MainGallery.vue?vue&type=template&id=3ff12f95&scoped=true&"
import script from "./MainGallery.vue?vue&type=script&lang=js&"
export * from "./MainGallery.vue?vue&type=script&lang=js&"
import style0 from "./MainGallery.vue?vue&type=style&index=0&id=3ff12f95&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff12f95",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
